import React from 'react';
import { UtensilsCrossed, Refrigerator, Snowflake, Bath, SprayCan, Ghost } from 'lucide-react';
import { Zone } from '../hooks/useInventory';
interface ZoneCardProps {
  name: Zone;
  itemCount: number;
  hasWarning: boolean;
  onClick: () => void;
}
const ZONE_CONFIG: Record<Zone, {
  icon: any;
  color: string;
  label: string;
}> = {
  'Kitchen Pantry': {
    icon: UtensilsCrossed,
    color: 'text-[#722F37]',
    label: 'Provisions'
  },
  Refrigerator: {
    icon: Refrigerator,
    color: 'text-[#2D5A3D]',
    label: 'Cold Storage'
  },
  Freezer: {
    icon: Snowflake,
    color: 'text-[#1E3A8A]',
    label: 'Deep Freeze'
  },
  Bathroom: {
    icon: Bath,
    color: 'text-[#C9A227]',
    label: 'Apothecary'
  },
  'Cleaning Closet': {
    icon: SprayCan,
    color: 'text-[#4A4A4A]',
    label: 'Maintenance'
  }
};
export function ZoneCard({
  name,
  itemCount,
  hasWarning,
  onClick
}: ZoneCardProps) {
  const config = ZONE_CONFIG[name] || {
    icon: Ghost,
    color: 'text-gray-500',
    label: name
  };
  const Icon = config.icon;
  return <button onClick={onClick} className={`
        relative group flex flex-col items-center p-5 rounded-xl border-2 transition-all duration-300
        active:scale-[0.98] bg-[#FFFDF5]
        ${hasWarning ? 'border-[#8B0000] shadow-[0_0_10px_rgba(139,0,0,0.1)]' : 'border-[#C9A227]/30 hover:border-[#C9A227] hover:shadow-[0_4px_12px_rgba(201,162,39,0.15)]'}
      `} data-id="element-84">
      {/* Corner Flourishes */}
      <div className="absolute top-1 left-1 w-2 h-2 border-t border-l border-[#C9A227] opacity-30 group-hover:opacity-100 transition-opacity" data-id="element-85" />
      <div className="absolute top-1 right-1 w-2 h-2 border-t border-r border-[#C9A227] opacity-30 group-hover:opacity-100 transition-opacity" data-id="element-86" />
      <div className="absolute bottom-1 left-1 w-2 h-2 border-b border-l border-[#C9A227] opacity-30 group-hover:opacity-100 transition-opacity" data-id="element-87" />
      <div className="absolute bottom-1 right-1 w-2 h-2 border-b border-r border-[#C9A227] opacity-30 group-hover:opacity-100 transition-opacity" data-id="element-88" />

      <div className={`w-14 h-14 rounded-full flex items-center justify-center mb-3 bg-[#F5F0E1] border border-[#C9A227]/20 group-hover:scale-110 transition-transform duration-300`} data-id="element-89">
        <Icon className={`w-7 h-7 ${config.color}`} data-id="element-90" />
      </div>

      <h3 className="font-cinzel font-bold text-center text-[#2C2C2C] mb-1 text-sm leading-tight" data-id="element-91">
        {config.label}
      </h3>

      <div className="text-[10px] uppercase tracking-widest text-[#722F37]/60 mb-2 font-serif" data-id="element-92">
        {name}
      </div>

      <div className="flex items-center gap-1.5 bg-[#F5F0E1] px-3 py-1 rounded-full border border-[#C9A227]/20" data-id="element-93">
        <span className="text-xs font-medium text-[#555]" data-id="element-94">
          {itemCount} items
        </span>
        {hasWarning && <span className="w-2 h-2 rounded-full bg-[#8B0000] animate-pulse shadow-[0_0_4px_#8B0000]" data-id="element-95" />}
      </div>
    </button>;
}